import { render, staticRenderFns } from "./product-stats.vue?vue&type=template&id=2e86d990&"
import script from "./product-stats.vue?vue&type=script&lang=js&"
export * from "./product-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports